import React from 'react'
import TechnicalServicePage from '../components/TechnicalServicePage'
import { useTranslation } from 'react-i18next'

const AgricultureFoodPage = () => {
  const { t } = useTranslation()
  const parentBreadcrumbs = [
    { label: t('header.home'), path: '/' },
    { label: t('header.service'), path: '/service' },
    { label: t('header.services.consultancy.title'), path: '/service/consultancy' }
  ]
  return (
    <TechnicalServicePage 
      serviceKey="agricultureFood"
      translationKey="servicesData.agricultureFood"
      parentBreadcrumbs={parentBreadcrumbs}
    />
  )
}

export default AgricultureFoodPage
